import React from "react";

const DEFAULT_IMAGE = "/img/bg-04.jpg";

const PRESETS = {
    contact: (product: string) => ({
        title: `${product} 도입에 대해 궁금하신 점이 있다면 \n ${product} 전문가와 지금 상의해 보세요.`,
        subtitle: "",
        button: "문의하기",
        href: "/contact"
    }),
    recruit: () => ({
        title: "KUSRC 에 합류하세요.",
        subtitle:
            "케이유융합소프트웨어가 만드는 수많은 혁신의 순간들, 당신과 함께 만들고 싶습니다. \n 지금, KUSRC 에 합류하세요.",
        button: "지원하기",
        href: "/recruit/jobs"
    })
} as const;

type CtaProps = {
    preset?: keyof typeof PRESETS;
    product?: string;
    title?: string;
    subtitle?: string;
    button?: string;
    href?: string;
    imageSrc?: string;
    reverse?: boolean;
};

const Cta = ({
    preset,
    product = "",
    title,
    subtitle,
    button,
    href,
    imageSrc,
    reverse = true
}: CtaProps) => {
    const base =
        preset === "contact"
            ? PRESETS.contact(product)
            : preset === "recruit"
              ? PRESETS.recruit()
              : { title: "", subtitle: "", button: "문의하기", href: "/contact" };

    const heading = title ?? base.title;
    const lead = subtitle ?? base.subtitle;
    const label = button ?? base.button;
    const link = href ?? base.href;
    const image = imageSrc ?? (preset ? DEFAULT_IMAGE : "");

    return (
        <div
            className={`relative ${image ? "bg-cover bg-center" : ""}`}
            style={{ backgroundImage: `url("${image}")` }}
        >
            {reverse && <div className="absolute inset-0 z-10 bg-black opacity-70" />}

            <div className="relative z-20 mx-auto flex max-w-7xl flex-col justify-center px-6 py-section sm:px-10 lg:min-h-96 lg:flex-row lg:items-center lg:justify-between lg:px-8">
                <h2 className="font-bold text-gray-900">
                    <div
                        className={`block text-balance break-keep text-h3 font-bold sm:whitespace-pre-line sm:text-h2 ${
                            reverse ? "text-gray-100" : ""
                        }`}
                    >
                        {heading}
                    </div>
                    {lead && (
                        <div
                            className={`mt-5 block text-lead font-normal whitespace-pre-line ${
                                reverse ? "text-gray-100" : "text-accent"
                            }`}
                        >
                            {lead}
                        </div>
                    )}
                </h2>
                <div className="mt-4 sm:mt-8 flex lg:mt-0 lg:flex-shrink-0">
                    <div className="inline-flex rounded-md shadow">
                        <a
                            href={link}
                            className="inline-flex items-center justify-center rounded-md border border-transparent bg-accent px-3 py-2 text-caption font-medium text-white hover:bg-accent-dark sm:px-5 sm:py-3 sm:text-base "
                        >
                            {label}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cta;
